import React, { useState } from 'react';
import { useTutorial } from '../../contexts/TutorialContext';
import TutorialStep from './TutorialStep';
import TutorialProgress from './TutorialProgress';
import './TutorialOverlay.css';

const TutorialOverlay: React.FC = () => {
  const { state, skipTutorial } = useTutorial();
  const [isVisible, setIsVisible] = useState(false);

  // Prüfe ob der User eingeloggt ist
  const isAuthenticated = () => {
    const accessToken = localStorage.getItem('accessToken') || sessionStorage.getItem('accessToken');
    return !!accessToken;
  };

  // Debug: Tutorial-State prüfen
  console.log('🔍 TutorialOverlay: state.isActive =', state.isActive);
  console.log('🔍 TutorialOverlay: state.currentStep =', state.currentStep);

  // Zeige Tutorial nur wenn der User eingeloggt ist UND das Tutorial aktiv ist
  if (!isAuthenticated()) {
    console.log('🔒 User nicht eingeloggt - zeige kein Tutorial');
    return null;
  }

  if (!state.isActive) {
    console.log('❌ Tutorial nicht aktiv - zeige nichts');
    return null;
  }

  console.log('✅ Tutorial ist aktiv - zeige Overlay');

  const handleSkip = () => {
    if (window.confirm('Möchtest du das Tutorial wirklich überspringen? Du kannst es später in den Einstellungen wiederholen.')) {
      skipTutorial();
      // Direkt zum Dashboard weiterleiten, um Daten der richtigen Organisation zu laden
      window.location.href = '/dashboard';
    }
  };

  const handleClose = () => {
    setIsVisible(false);
    // Kurz warten und dann Tutorial beenden und zum Dashboard weiterleiten
    setTimeout(() => {
      skipTutorial();
      // Direkt zum Dashboard weiterleiten, um Daten der richtigen Organisation zu laden
      window.location.href = '/dashboard';
    }, 300);
  };

  return (
    <div className="tutorial-overlay">
      <div className="tutorial-container">
        {/* Header mit Progress und Skip-Button */}
        <div className="tutorial-header">
          <div className="tutorial-title">
            <h2>ASMonitor Einrichtung</h2>
            <p>Schritt {state.currentStep} von 6</p>
          </div>
          <div className="tutorial-actions">
            <button 
              className="tutorial-skip-btn"
              onClick={handleSkip}
            >
              Überspringen
            </button>
            <button 
              className="tutorial-close-btn"
              onClick={handleClose}
            >
              ✕
            </button>
          </div>
        </div>

        {/* Progress Bar */}
        <TutorialProgress currentStep={state.currentStep} totalSteps={6} />

        {/* Tutorial Content */}
        <div className="tutorial-content">
          <TutorialStep />
        </div>
      </div>
    </div>
  );
};

export default TutorialOverlay;
